module.exports = __webpack_public_path__ + "img/medical-expenses-icon.8e328492.svg";